<template>
  <div id="wrapper">
    <Nav :message="message" />
    <BackoutList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import BackoutList from '@/components/revenue/BackoutList.vue'

export default {
  name: 'backout',
  props: ['message'],
  components: {
    Nav,
    BackoutList
  }
}
</script>